'use client'

import { useMemo } from 'react'

/**
 * Returns `true` when the user agent looks like macOS, `false` otherwise.
 *
 * Used to choose Mac-vs-Windows/Linux key labels (e.g. `⌘ K` vs `Ctrl K`) and to render
 * platform-appropriate hints in the keyboard-shortcuts overlay and QuickSearch bar.
 *
 * `'use client'` guarantees this hook only runs in the browser, so `navigator.userAgent`
 * is always defined at call time. Memoized so the check runs once per mount rather than
 * on every render — the user agent doesn't change inside a session.
 */
export default function useIsMac(): boolean {
  return useMemo(() => /Macintosh/.test(navigator.userAgent), [])
}
